import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class ImportCustomerJobs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
        };
    }
    
    handleImportCustomerJobs(e) {
      this.setState({isLoading:true});
      const input = document.getElementById('new_customer_job_import');
      let file = input.files[0];
      const data = new FormData();
      data.append('new_customer_job_import',file,file.name );
      
      return fetch(
        '/api/v1/portal/customers/import-customer-jobs',
        {
          method: 'POST',
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            ,"Accept": 'application/json'
          },
          body: data,
        }).then((responseText) => {
            let response = responseText.json();
            this.setState({isLoading:false});
            response.then((response) => {
              $('#infomodallabel').html('Success');
              $('#infomodal .modal-body').html(response);
              $('#infomodal').modal();
            });
        }).catch((error) => {
          this.setState({isLoading:false});
            $('#infomodallabel').html('Error');
            $('#infomodal .modal-body').html(error);
            $('#infomodal').modal();
          }
        );
    }
    render() {
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Import Customer Moves</h2>
                    <br/>
                    <br/>
                </div>
                <div className="row col-md-6 subsection-container">
                  <div className="col-md-4">
                    <input
                      type="file"
                      name="new_customer_job_import"
                      id="new_customer_job_import"
                    />
                  </div>
                  <div className="col-md-6 text-center">
                    <button
                      className="btn btn-lg btn-primary"
                      disabled={(this.state.isLoading) ? true : false}
                      onClick={(e) => {
                        this.handleImportCustomerJobs(e);
                      }}
                    >
                      <i className="fa fa-upload"></i>&nbsp;
                        Upload & Import Customer Moves
                    </button>
                  </div>
                  <br/>
                  <br/>
                  <div className="col-md-12">
                      <small>Download <a href="/import/import-customer-jobs.csv" download> sample file from here.</a></small>
                  </div>
                  <br/>
                  <br/>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-customer-import-customer-jobs')) {
    ReactDOM.render(
        <ImportCustomerJobs message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-customer-import-customer-jobs')
    );
}
